'use strict';

angular.module('substoreApp.controllers').controller('masterController', ['$rootScope', '$scope', '$location', '$window', '$anchorScroll', '$translate', 'sessionData', 'partnerFeatureRegistry', 'throwServiceResponseFault', 'progressBar',
    function ($rootScope, $scope, $location, $window, $anchorScroll, $translate, sessionData, partnerFeatureRegistry, throwServiceResponseFault, progressBar) {
        $scope.sessionData = sessionData;

        /*
         * convencience functions for partner feature support
         */
        $scope.lookupFeature = partnerFeatureRegistry.lookupTemplate;
        $scope.applyFeature = partnerFeatureRegistry.applyWithScope;

        /**
         * Generic error handling methods
         */
        $scope.throwServiceResponseFault = throwServiceResponseFault;

        /**
         * breadcrumb - configure data structure and methods to be reused by every specific controller
         */
        $scope.breadcrumb = {
            crumbs: undefined,
            init: function (name, url) {
                this.crumbs = [
                    { name: name, url: url }
                ];
                this.updateTitle(name);
            },
            add: function (name, url) {
                this.crumbs.push({ name: ">" });
                this.crumbs.push({ name: name, url: url });
                this.updateTitle(name);
            },
            updateTitle: function (name) {
                // 3.2.3 Page Title
                // Note: we cannot use angularjs binding for <title> element, because it doesn't work with IE8
                // Note: title is first set in app.js
                $translate('title').then(function (title) {
                    $translate(name).then(function (title2) {
                        $window.document.title = title + ' - ' + title2;
                    });
                });
            }
        };

        /**
         * progress bar (required in most controllers)
         */

        $scope.progressBar = progressBar;

        /**
         * teaser
         */
        $scope.resetTeaser = function () {
            $scope.teaser = {
                title: "",
                subtitle: "",
                imageResourcePath: null,
                imageResourcePathFallback: null
            };
        };

        $scope.updateTeaser = function (title, subTitle, imageResourcePath) {
            if (title) {
                $scope.teaser.title = title;
                $scope.teaser.subtitle = subTitle;
            } else {
                // CAP-533
                $translate('teaser_default_title').then(function (translation) {
                    $scope.teaser.title = translation;
                });
                $translate('teaser_default_subtitle').then(function (translation) {
                    $scope.teaser.subtitle = translation;
                });
            }
            if (imageResourcePath) {
                $scope.teaser.imageResourcePath = "../../resources/" + imageResourcePath;
            } else {
                var natCoName = sessionData.dialogStaticData.natCoName;
                var wpid = sessionData.dialogStaticData.wholesalePartnerId;
                var randomNumber = Math.floor(Math.random() * 10 % 4 + 1).toString(); // from 1 to 4
                $scope.teaser.imageResourcePathFallback = "img/teaser" + randomNumber + ".jpg";
                if (natCoName && wpid) {
                    // the resource must exist! (but if it doesn't then HTML uses the fallback, see indexheader.html)
                    $scope.teaser.imageResourcePath = "natco/" + natCoName + "/teaser" + randomNumber + "-" + wpid + ".jpg";
                } else {
                    // natCoName and wpid are only undefined in case of errors. In this case we show generic default pictures
                    $scope.teaser.imageResourcePath = $scope.teaser.imageResourcePathFallback;
                }
            }
        };

        $scope.resetTeaser();

        $rootScope.$on("$locationChangeStart",
            function (event, next, current) {
                $scope.resetTeaser();
            });

        /**
         * Go to a certain location.
         * Useful in buttons or links, e.g.:
         * &lt;a ng-href="{{go('/subdialog')}}&gt;link&lt;/a&gt;
         *
         * @param path (string) relative or absolute path
         * @param [replace] (boolean) if true, all changes to $location
         * during current "$digest" will be replacing current history
         * record, instead of adding new one
         */
        $scope.go = function (path, replace) {
            $location.path(path);
            if (replace) {
                $location.replace();
            }

            return $location;
        };

        /**
         * Go to either myproducts or catalogue - if allowed
         */
        $scope.cancel = function (/*boolean*/ toMyProducts) {
            var targetLocation = null;

            if (toMyProducts && sessionData.dialogStaticData.showMyProducts)
                targetLocation = "/myproducts";
            else if (!toMyProducts && sessionData.dialogStaticData.showCatalogue)
                targetLocation = "/catalogue";
            else
                throw { code: "CANCEL_TARGET_DIALOGUE_NOT_ALLOWED" };

            $location.path(targetLocation);
        };

        /**
         * Let the browser go back.
         * Useful in buttons or links: <a ng-href="{{back()}}>go back</a>
         */
        $scope.back = function () {
            $window.history.back();
        };

        /**
         * Go to top of page
         */
        $scope.goTop = function () {
            $anchorScroll();
        };

        /**
         * configure global idiomatic routing rules
         */
        $rootScope.$on("$locationChangeStart",
            function (event, next, current) {
                var nextToken = next.match("#/[^/#]*");
                var currentToken = current.match("#/[^/#]*");

                function contains(a, o) {
                    for (var i = 0; i < a.length; i++) {
                        if (a[i] === o) {
                            return true;
                        }
                    }
                    return false;
                }

                if (currentToken) {
                    switch (currentToken[0]) {
                        case "#/orderconfirmation" :
                        case "#/productchangeconfirmation" :
                        case "#/orderadministrationconfirmation" :
                            if (current !== next)
                                sessionData.deleteCurrentSubscription();
                            if (nextToken[0] && !contains(["#/", "#/myproducts", "#/catalogue", "#/logout", "#/error", currentToken[0]], nextToken[0]))
                                event.preventDefault();
                            break;
                        case "#/logout" :
                            if (nextToken[0] && !contains(["#/logout", "#/error", currentToken[0]], nextToken[0]))
                                event.preventDefault();
                            break;
                    }
                }

                if (nextToken) {
                    // temporary 18.2.1 solution: if logout button must not be shown then we
                    // know that catalogue and myproducts are not provided by substore itself
                    var target = nextToken[0];
                    if (sessionData.dialogStaticData && sessionData.dialogStaticData.showLogout === false && (target == "#/catalogue" || target == "#/myproducts")) {
                        $location.path( "/logout" + target.substring(1) );
                    }

                    // each part might deliver its own footnotes (or not). Unfortunately those footnotes
                    // are part of footer rather than variable part of view so we have to reset here
                    $scope.footnotes = "";
                }
            }
        );

        /* provide custom resources */

        $scope.customResource = function(key) {
            return sessionData && sessionData.dialogStaticData && sessionData.dialogStaticData.customResources && sessionData.dialogStaticData.customResources[key];
        };
    }
]);